<qrcode [qrdata]="data()" [width]="width()" [errorCorrectionLevel]="'M'" />